import { User } from "oidc-client-ts";
import { useDotNetController } from "../useDotNetController/useDotNetController";

export const useAdminController = <T,>(
  user?: User,
  cacheResponse: boolean = true
) => {
  return useDotNetController<T>("Admin", user, cacheResponse);
};
